import React from "react";

import Header from "../../general/Header";
import Aside from "../../general/Aside";
import Footer from "../../general/Footer";
import axios from '../../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../../general/Loading";

function EditarConvenio() {

    const queryParams = new URLSearchParams(window.location.search);
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const search = useLocation().search;
    const id = new URLSearchParams(search).get('id');
    const [empresas, setEmpresas] = useState([]);
    
    const [nombre, setNombre] = useState('');
    const [codigo, setCodigo] = useState('');
    const [empresa, setEmpresa] = useState('');
    const [porcentajeGlobal, setPorcentajeGlobal] = useState('');
    const [errorlist, setErrorlist] = useState({});

    let history = useHistory();

    let userdata = [];

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        
        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('/empresas?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setEmpresas(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });
        
        const config2 = {
            params: {
                uid: userdata.user_id,
                id: id
            }
        }

        axios.get('/convenio',config2)
            .then(response => {
                console.log(response.data[0]);
                setNombre(response.data[0].nombre);
                setCodigo(response.data[0].codigo);
                setEmpresa(response.data[0].empresa);
                setPorcentajeGlobal(response.data[0].porcentaje_global);
            })
            .catch(error => {
                console.log(error);
            });
    },[]);


    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        const conf = {
            headers: { Authorization: 'Bearer ' + userdata.access_token },
            uid: userdata.user_id,
            id: id,
            nombre: nombre,
            codigo: codigo,
            empresa: empresa,
            porcentaje_global: porcentajeGlobal
        };
        
        axios.put('/convenio', conf)
            .then(
                response => {
                    setLoading(false);
                    localStorage.setItem('toastmsg', 'El convenio "'+nombre+'" ha sido modificado');
                    history.push('/convenios');
                }
            )
            .catch(
                err => {
                    console.log(err);
                    setErrorlist(err.response.data.errors);
                    setLoading(false);
                }
            )
    }


    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                    <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/administrar-convenios">Administrar Empresas y Convenios</Link></li>
                                        <li className="breadcrumb-item" key="bc4"><Link to="/convenios">Convenios</Link></li>
                                        
                                        <li className="breadcrumb-item" key="bc5">Editar Convenio</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Editar Convenio</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                            <div className="col-md-10">
                                
                                <div className="card">
                                <div id="infobasica">
                                    <div className="card-body">

                                        <form id="role-form" onSubmit={handleSubmit}>
                                            <div className="row">

                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="nombre">Nombre</label>
                                                        <input type="text" name="nombre" className="form-control" id="nombre" value={nombre} onChange={(e) => setNombre(e.target.value)} />
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.nombre}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="codigo">Empresa</label>
                                                        <select name="codigo" className="form-control" id="codigo" value={empresa} onChange={(e) => setEmpresa(e.target.value)}>
                                                            {
                                                                empresas.map((emp) => 
                                                                    <option value={emp.id} key={emp.id}>{emp.nombre_empresa}</option>
                                                                )
                                                            }
                                                        </select>
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.empresa}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="codigo">Código</label>
                                                        <input type="text" name="codigo" className="form-control" id="codigo" value={codigo} onChange={(e) => setCodigo(e.target.value)} />
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.codigo}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="porcentajeGlobal">Porcentaje de descuento global</label>
                                                        <input type="text" name="porcentajeGlobal" className="form-control" id="porcentajeGlobal" value={porcentajeGlobal} onChange={(e) => setPorcentajeGlobal(e.target.value)} />
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.porcentaje_global}
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="row" style={{marginTop: '30px'}}>
                                                <div className="col-md-6">
                                                    <button type="submit" className="btn btn-primary btn-block">
                                                        Guardar cambios&nbsp;
                                                        {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                                        
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                </div>

                            </div>          
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default EditarConvenio;